import VueElementLoading from 'vue-element-loading';
import {BasicSelect,MultiSelect} from 'vue-search-select';
import CreateODACharge from './../createODACharge';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import MasterService from './../../../services/masterdata.service';
import CONSTANT from './../../../../shared/constants/constant';
import Util from './../../../../shared/util/util';

export default {
  name: 'ODAChsrgeTemplate',
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    CreateODACharge,
    VueElementLoading,
    CustomExpandableTable
  },
  data: function() {
    return {
      templateName: '',
      templateNameSearch: '',
      type: 'ODA_CHARGE_MASTER',
      isLoading:false,
      showCreateOda: false,
      currentPage: 1,
      totalPage: 1,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: ['Template Name', 'Template Description','Created By','Created Date','Status','Action'],
      innerTableColumn: ['Assigned Zones'],
      tableItems: [],
      selectedEditRowObject:null,
      apiResponse : null,
      selectedOdaChargeId:null,
      status:"",
      statusSearch:"",
      statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
    }
  },
  computed: {

  },
  mounted() {
    this.getOdaChargeListing();
  },
  methods: {
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    async activeAction(data){
      try {
        this.isLoading = true;
        var item = this.apiResponse.find(item => item.id === data.id);
        var isactivestatus = item.status == 0 ? 1 : 0
        let inputPayload = {
          "id": data.id,
          "type": this.type,
          "status": isactivestatus
        }
        let result = await MasterService.changeStatus(inputPayload)
        if(result.data.code == 200){
          if(result.data.data[0].status == 0){
          this.$alert("ODA Charge Template Activated Successfully!!", "", "success");
        }else{
          this.$alert("ODA Charge Template Inactivated Successfully!!", "", "success");
         }
          this.getOdaChargeListing();
          this.isLoading = false;
        }
      } catch(err){
        console.log(err);
      }
    },
    searchOdaChargeListing(){
      this.currentPage = 1;
      this.offset = 0;
      this.templateNameSearch = this.templateName;
      this.statusSearch = this.status;
      this.getOdaChargeListing();
    },
    async getOdaChargeListing() {
      try {
        this.isLoading = true;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit
        }
        if(this.templateNameSearch!=""){
          inputPayload.odatemplatename = this.templateNameSearch;
        }
        if(this.statusSearch!=""){
          inputPayload.status = this.statusSearch;
        }
        let result = await MasterService.getOdaChargeList(inputPayload);
        this.apiResponse = result.data.data.rows;
        this.isLoading = false;
        this.tableItems = result.data.data.rows.map((el) => {
          return {
            'id': el.id,
            'Template Name': el.odatemplatename,
            'Template Description': el.odatemplatedescription,
            'Created By':el.createdby,
            'Created Date':Util.displayDateTimeFormat(el.createddate),
            'Status': el.status,
         }
        })
        this.totalCount = result.data.data.count
        this.resultCount = result.data.data.count;
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false
        //console.log(result);
      } catch (err) {
        this.isLoading = false
        console.log(err);
      }
    },
    clearForm() {
      this.currentPage =  1,
      this.templateName = '';
      this.templateNameSearch = '';
      this.status = "";
      this.statusSearch = "";
      this.statusitem = {};
      this.getOdaChargeListing();
    },
    showServiceArea() {
      this.showCreateOda = true;
    },
    callParent() {
        this.selectedOdaChargeId = null;
        this.showCreateOda = false;
        this.currentPage = 1;
        this.offset = 0;
        this.selectedEditRowObject = [];
        this.selectedOdaChargeId =null;
        this.getOdaChargeListing();
      },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getOdaChargeListing();
    },
    getCustomTableEvent(event){
      if(event.actionType=="active"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       });
     }else if(event.actionType=="inactive"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       })
      }
      if(event.actionType == 'edit'){
        this.selectedOdaChargeId = event.id;
        let selectedEditRow  = this.apiResponse.filter(function(items) {
          return items.id == event.id;
        });
        this.selectedEditRowObject = selectedEditRow[0];
        this.showCreateOda = true;
      }
    },
    goBackToParent(){
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ODAChargeTemplate/ODAChargeListing/ODAChargeListing.component.js